import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useParams, useHistory } from 'react-router-dom'
import Animate from 'rc-animate';
import { Row, Col, Spin, Result, Button} from 'antd'
import { courseActions } from '../../redux/reducers/course';
import LessonView from './LessonView';
import LessonList from './LessonList';
import NotFound from '../NotFound'


const Education = () => {
    let { id } = useParams();
    const history = useHistory()
    const dispatch = useDispatch();
    const user = useSelector(state => state.user)
    const loading = useSelector(state => state.course.isFetching)
    const isError = useSelector(state => state.course.isError)
    const errorMessage = useSelector(state => state.course.errorMessage)

    useEffect(() => {
            dispatch(courseActions.getCourse(user.jwt, id))
    }, []);


    if(loading){
        return(
            <Row justify="center">
                <Col>
                    <Spin
                        size="large"
                        spinning={loading}
                        delay={100}
                    ></Spin>
                </Col>
            </Row>
        )
    }
    if(isError && errorMessage ) {    
        if(errorMessage.status == "403"){
            return (
                <Result
                status="warning"
                title="This content available only for Odin Subscribed Members"
                extra={
                  <Button type="primary" key="goPro"
                    onClick={()=>{history.push("/services")}}
                    >
                    Become Odin Member
                  </Button>
                }
              />
            )
        }else{
            return <NotFound/>
        }
    } 


    return (
        <Animate
            transitionName="fade"
            transitionAppear
        >
            <Row gutter={[16,16]} justify="center">
                <Col xs={24} sm={24} md={16} lg={16} xl={14}>

                    <LessonView/>
                    

                </Col>
                <Col xs={24} sm={16} md={14} lg={8} xl={8}>
                    <LessonList/>
                </Col>
            </Row>
        </Animate>
    )
}

export default Education
